<!-- Gateway Lamps Insert @show="fillModal"   
  :ok-title="$t('gateway_lamps_insert_modal.send')"
      @ok="sendGatewayLampsInsertCommand"   
      
  -->
<template>
    <b-modal
      :visible="visible"    
      @change="change"
      @hidden="hide"     
      ref="modal"
      id="modal-gateway-lampsSelected-insert"
      :title="$t('gateway_lamps_insert_modal.title')"
      size="lg"
      centered
      no-close-on-backdrop
      no-close-on-esc
      modal-class="modal-dialog-scrollable"     
    >
      <div v-if="zones.length" class="px.2">
        <b-row>
          <b-col          
            v-for="(zone, index) in zones"
            :key="index"
            cols="12"
            md="6"
            class="mb-3"
          >         
            <b-card
                class="shadow-sm"
                :bg-variant="zonesSelected[zone.zoneNumber] ? 'light' : 'white'"
                :border-variant="zonesSelected[zone.zoneNumber] ? 'primary' : 'secondary'"
              >
              <!-- Header personalizzato -->
              <template #header>
                <div class="d-flex justify-content-between align-items-center">
                  <span :id="`zone-${zone.zoneNumber}`" class="h6 mb-0"><strong>{{ zone.zoneName }}</strong></span>
                  <b-form-checkbox 
                    v-model="zonesSelected[zone.zoneNumber]"
                    switch
                    :aria-labelledby="`zone-${zone.zoneNumber}`"
                    @input="updateSelected(zone.zoneNumber)"
                  />
                </div>
              </template>
              <!-- Body della card -->       
                <div class="d-flex flex-column align-items-start">
                  <div class="mb-1">{{ $t('gateway_lamps_insert_modal.zone') }} {{ zone.zoneNumber }}</div>
                  <div class="mb-0">{{ zone.bleLamps.length }} {{ $t('gateway_lamps_insert_modal.num_lamps') }}</div>
                </div>
              </b-card>
          </b-col>          
        </b-row>
        <!-- <div class="d-flex align-items-center justify-content-center">{{$t('gateway_lamps_insert_modal.select_lamps')}}: {{ lampsSelected.length }}</div> -->
      </div>
      <div v-else class="text-center text-muted">
        <p>{{ $t('gateway_lamps_insert_modal.no_zones')  }}</p>
      </div>
      <template #modal-footer>
        <div class="d-flex w-100 justify-content-center">
          {{$t('gateway_lamps_insert_modal.select_lamps')}}: {{ lampsSelected.length }}
        </div>
        <b-button
          variant="secondary"
          size="md"
          @click="closeModal"
          class="ml-auto mr-3 text-nowrap"
        >
          {{ $t('gateway_command_modal.cancel') }}
        </b-button>
        <b-button
          variant="primary"
          size="md"
          class="ml-auto"
          @click="sendGatewayLampsInsertCommand"
        >
          <span class="text-nowrap">
            {{ $t('gateway_lamps_insert_modal.send') }}
          </span>
        </b-button>
      </template>
    </b-modal> 
</template>

<script>
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import { mapState } from 'vuex';

export default {
  components: {
    VueSlider
  },
  name: "GatewayLampsInsert",
  model: {
    prop: "visible",
    event: "change"
  },
  props: {
    cu: {
      default: null
    },
    zones: {
      default: []
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['data-ready', 'searching-finished'],
  data() {
    return {
      lampsSelected: [],
      zonesSelected: {},
      searching: false
    };    
  },

  mounted() {
    this.fillModal();
  },

  watch: {
    zones(newVal) {
      console.log("watch zones, newValue: ", newVal);
      this.fillModal();
    },
  },

  methods: {
    closeModal() {
      this.$refs.modal.hide();
    },
    hide() {
      this.$emit("hide");
    },
    change(visible) {
      this.$emit("change", visible);
    },
    //------------------------------------------------------------------------------------------
    //se viene selezionata una zona, aggiunge le rispettive lampade all'array lampsSelected
    //se viene deselezionata una zona, toglie le rispettive lampade a lampsSelected
    //------------------------------------------------------------------------------------------
    updateSelected(num) {
      let selzone = this.zones.find(zone => zone.zoneNumber === num);
      for(var n=0; n<selzone.bleLamps.length; n++) {
        if (this.zonesSelected[num]) {
          this.lampsSelected.push(selzone.bleLamps[n]);
        } else {
          this.lampsSelected.splice(this.lampsSelected.indexOf(selzone.bleLamps[n]), 1);
        }
      }
    },
    //------------------------------------------------------------------------------------------    
    //funzione invocata alla visualizzazione del modal (@shown)
    //------------------------------------------------------------------------------------------
    fillModal() {
      //compilo le variabili zonesSelected e lampsSelected, che vanno prima resettate
      this.zonesSelected = {};
      this.lampsSelected = [];
      //console.log("fillModal, zonesSelcted: ", this.zonesSelected, " lampsSelected: ", this.lampsSelected);
      this.zones.forEach((zone) => {
        this.zonesSelected[zone.zoneNumber]=false;
        this.cu.zones.forEach((zoneGateway)=>{
          if(zone.zoneNumber === zoneGateway.zoneNumber) {
            //console.log("fillModal, zone.zoneNumber: ", zone.zoneNumber, " zoneGateway.zoneNumber: ", zoneGateway.zoneNumber);
            this.zonesSelected[zone.zoneNumber]=true;
            for(var n=0; n<zone.bleLamps.length; n++)
            {
              this.lampsSelected.push(zone.bleLamps[n]);
            }
            //console.log("fillModal, lampsSelected: ", this.lampsSelected);
          }
        })
      });
      //console.log("fillModal, zonesSelected: ", this.zonesSelected);
    },  

    //--------------------------------------------------------------------------------
    //funzione che avvia il polling durante la fase di ricerca delle lampade
    //--------------------------------------------------------------------------------
    startSearchProcess() {
      this.searching = true;
      const cuInfo = {
        'cuid': this.cu.cu_id,
        'cutype': this.cu.cu_type,
        'plant': this.cu.plantId
      };
      const data = { 
        action: 'gatewayGetDataPlant', 
        payload: cuInfo
      };
      this.startPollingForSearch(data);
    },

    //--------------------------------------------------------------------------------
    // funzione che invia il comando di polling ogni x secondi e decodifica la response
    //--------------------------------------------------------------------------------
    async startPollingForSearch(data) {
      if (!this.searching) return; // Exit if searching is stopped
      try {
        const responseData = await this.$store.dispatch('sendGatewayCommand', data);
        console.log("Received response:", responseData);
        if (responseData.message_attribute.searching == '0' && responseData.message_attribute.polling == '0') {
          this.searching = false; // Set the flag to false to stop the loop
          console.log("Search completed successfully based on server response.");
          this.$emit('searching-finished');
        }
        //passo al parent (Centrali.vue) i dati ricevuti affinché possa passarli a GatewayLampsSearch.vue che monitora la ricerca
        this.$emit('data-ready', responseData);
      } catch(error) {
        console.error("Error during search command. Halting polling.", error);
        // If any error (timeout, network, or server rejection) occurs, stop polling.
        this.searching = false;      
      }
      // Schedule the next attempt ONLY if still searching
      if (this.searching) {
            setTimeout(() => {
                // Recursively call the function after 2 seconds
                this.startPollingForSearch(data);
            }, 2000);
        }
    },

    //--------------------------------------------------------------------------------
    // funzione che invia al gateway i dati delle lampade da controllare
    //--------------------------------------------------------------------------------
    async sendGatewayLampsInsertCommand(bvModalEvt) {

      let sequenceSucceeded = false; // Flag to track success
      // Prevent modal from closing
      bvModalEvt.preventDefault();
     
      //predispongo 4 pagine da 16 indirizzi mac
      var lamps_mac_0=[];
      var lamps_mac_1=[];
      var lamps_mac_2=[];
      var lamps_mac_3=[];
      var lamps_serial=[];
      var lamps_type=[];
      var lamps_zone=[];

      for(var n=0; n<this.lampsSelected.length; n++)
      {
        //create mac arrays in 4 pages
        if(n<16)
          lamps_mac_0.push(this.lampsSelected[n].lamp.mac_address.replaceAll(":", ""));
        if(n>=16 && n<32)
          lamps_mac_1.push(this.lampsSelected[n].lamp.mac_address.replaceAll(":", ""));
        if(n>=32 && n<48)
          lamps_mac_2.push(this.lampsSelected[n].lamp.mac_address.replaceAll(":", ""));
        if(n>=48 && n<64)
          lamps_mac_3.push(this.lampsSelected[n].lamp.mac_address.replaceAll(":", ""));
        
        //create lamp serial array
        lamps_serial.push(this.lampsSelected[n].id ? this.lampsSelected[n].id : "");
        //create lamp type array
        lamps_type.push(this.lampsSelected[n].model ? this.lampsSelected[n].model.toString(16).padStart(2,"0").toUpperCase() : "");
        //create lamp zone array
        lamps_zone.push(this.lampsSelected[n].lamp.zone ? this.lampsSelected[n].lamp.zone.toString(16).padStart(2, '0').toUpperCase() : "");
      }

      let gatewayZonesArray = [];
      for (const [zoneNumber, isSelected] of Object.entries(this.zonesSelected)) {
        //console.log(`Zone Number: ${zoneNumber}, Is Selected: ${isSelected}`);
        if (isSelected) {
          const zone = this.zones.find(z => z.zoneNumber === parseInt(zoneNumber));
          const zoneId = zone ? zone.zoneId : null;
          // Filter lamps that belong to the current zone, avoiding to use the one in zone.bleLamps because it could be out-of-sync with lampsSelected
          const bleLampsInZone = this.lampsSelected.filter(lamp => lamp.lamp.zone === parseInt(zoneNumber));
          //console.log(`For Zone Number: ${zoneNumber}, found Zone ID: ${zoneId} and BLE Lamps: `, bleLampsInZone);
          gatewayZonesArray.push({ zoneNumber: parseInt(zoneNumber), zoneId: zoneId, bleLamps: bleLampsInZone });
        }
      }

      //sequenza comandi al Gateway: Mac 0, Mac 1, Mac 2, Mac 3, Serial, Type, Zone + Validate
      const commands = [
        { action: 'gatewayInsertMacCommand', payload: { cuid: this.cu.cu_id, cutype: this.cu.cu_type, plant: this.cu.plantId, page: "0", lampsmac: lamps_mac_0 } },
        { action: 'gatewayInsertMacCommand', payload: { cuid: this.cu.cu_id, cutype: this.cu.cu_type, plant: this.cu.plantId, page: "1", lampsmac: lamps_mac_1 } },
        { action: 'gatewayInsertMacCommand', payload: { cuid: this.cu.cu_id, cutype: this.cu.cu_type, plant: this.cu.plantId, page: "2", lampsmac: lamps_mac_2 } },
        { action: 'gatewayInsertMacCommand', payload: { cuid: this.cu.cu_id, cutype: this.cu.cu_type, plant: this.cu.plantId, page: "3", lampsmac: lamps_mac_3 } },
        { action: 'gatewayInsertSerialCommand', payload: { cuid: this.cu.cu_id, cutype: this.cu.cu_type, plant: this.cu.plantId, lampsserial: lamps_serial } },
        { action: 'gatewayInsertTypeCommand', payload: { cuid: this.cu.cu_id, cutype: this.cu.cu_type, plant: this.cu.plantId, lampstype: lamps_type } },
        { action: 'gatewayInsertZonesCommand', payload: { cuid: this.cu.cu_id, cutype: this.cu.cu_type, plant: this.cu.plantId, lampszones: lamps_zone } },
        { action: 'gatewayValidate', payload: { cuid: this.cu.cu_id, cutype: this.cu.cu_type, plant: this.cu.plantId,} },
      ]
      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs.modal.hide();
      });
      this.$store.dispatch('attivaLoading');
      try {
        for (const command of commands) {
          await this.$store.dispatch('sendGatewayCommand', command);
        }
        //invio l'ultimo comando 'saveGatewayConfiguration', che è un POST al Backend e non viene inviato al Gateway
        await this.$store.dispatch('saveGatewayConfiguration', { gatewayId: this.cu.cu_id, cutype: this.cu.cu_type, plantId: this.cu.plantId, gatewayZones: gatewayZonesArray });
        sequenceSucceeded = true;
      } catch (error) {
        console.error("❌ Sequence halted due to failure:", error);
      }
      this.$store.dispatch('disattivaLoading');
      //attesa di 2sec
      await new Promise(r => setTimeout(r, 2000));
      if (sequenceSucceeded) {
        this.$bvModal.msgBoxConfirm(this.$t('gateway_lamps_insert_modal.searching'), {
          title: this.$t('gateway_lamps_insert_modal.confirm_search'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: this.$t('yes'),
          cancelTitle: this.$t('no'),
          footerClass: 'p-2 border-top-0',
          hideHeaderClose: false,
          centered: true,
          headerClass: 'p-2 border-bottom-0',
        })
        .then(async value => {
          if (value) {
            // 1. Define Command Payloads
            const cuInfo = {
              cuid: this.cu.cu_id,
              cutype: this.cu.cu_type,
              plant: this.cu.plantId,
              searchType: 4,
              searchTimeout: 300,
              resiThresold: 128,
              timeReport: 63
            };
            const searchCmd = {
              action: 'gatewaySearchBleDevice',
              payload: cuInfo
            };
            // 2. Send the INITIAL command to tell the Gateway to START searching
            await this.$store.dispatch('sendGatewayCommand', searchCmd);

            // 3. 🟢 CRITICAL: Start the continuous polling loop after sending the initial command.
            this.startSearchProcess();
          }
        })
        .catch(err => {
          console.error("❌ Error in msgBoxConfirm:", err);
        })       
      }
    },
  },
}

</script>

<style>
  /* Apply this style globally or scope it to your component */
  #modal-gateway-lampsSelected-insert .modal-dialog {
      /* Limit the height of the entire modal dialog (e.g., to 90% of viewport height) */
      max-height: 90vh;
  }

  #modal-gateway-lampsSelected-insert .modal-content {
      /* Ensure the content container fills the max-height */
      max-height: 90vh;
  }

  #modal-gateway-lampsSelected-insert .modal-body {
      /* This is critical: Make the body content scrollable */
      overflow-y: auto;
  }
</style>